import React from 'react';
import { Switch, Route, Redirect, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';

import TransactionContainer from './transactions/TransactionsContainer';
import ApplicationContainer from './applications/container/ApplicationContainer';

function miscellaneousFeeLPContainer({ match }) {
  const permissions = getJson('permissions');

  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">Miscellaneous Fees</div>
        <SideScrollingTab dragToScroll hideScrollButtons>
          <div className="generic-module-nav">
            {Acl(permissions, ['VIEW MISCELLANEOUS FEES DASHBOARD']) && (
              <NavLink
                exact
                className="nav-link"
                activeClassName="active"
                to="/miscellaneous-fee/transactions"
              >
                Dashboard
              </NavLink>
            )}
            {Acl(permissions, ['VIEW MISCELLANEOUS FEES TRANSACTIONS']) && (
              <NavLink
                exact={false}
                className="nav-link"
                activeClassName="active"
                to="/miscellaneous-fee/applications"
              >
                Applications
              </NavLink>
            )}
          </div>
        </SideScrollingTab>
        <Switch>
          {Acl(permissions, ['VIEW MISCELLANEOUS FEES DASHBOARD']) && (
            <Route
              path={`${match.path}/transactions`}
              component={TransactionContainer}
            />
          )}
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          {Acl(permissions, ['VIEW MISCELLANEOUS FEES TRANSACTIONS']) && (
            <Route
              path={`${match.path}/applications`}
              component={ApplicationContainer}
            />
          )}
        </Switch>
      </div>
    </>
  );
}

miscellaneousFeeLPContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default miscellaneousFeeLPContainer;
